import React, { createContext, useContext, useEffect, useState } from "react";

const GeneralSettingContext = createContext();

export const useGeneralSetting = () => useContext(GeneralSettingContext);

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const GeneralSettingProvider = ({ children }) => {
  const [generalSetting, setGeneralSetting] = useState(null);
  const [loading, setLoading] = useState(true);

  const showLoader = () => setLoading(true);
  const hideLoader = () => setLoading(false);

  useEffect(() => {
    fetch(`${API_BASE_URL}/v1/general-setting`)
      .then((res) => res.json())
      .then((res) => {
        const data = res?.data;
        setGeneralSetting(data);
        setLoading(false);

        if (!data) return;

        // favicon
        let favicon = document.querySelector("link[rel~='icon']");
        if (!favicon) {
          favicon = document.createElement("link");
          favicon.rel = "icon";
          document.head.appendChild(favicon);
        }
        favicon.href = data.favicon;

        // shortcut icon
        let shortcut = document.querySelector("link[rel='shortcut icon']");
        if (!shortcut) {
          shortcut = document.createElement("link");
          shortcut.rel = "shortcut icon";
          document.head.appendChild(shortcut);
        }
        shortcut.href = data.favicon;

        // title
        document.title = data.site_name || "Krishna finconcept services";
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <GeneralSettingContext.Provider
      value={{
        generalSetting,
        loading,
        showLoader,
        hideLoader,
      }}
    >
      {children}
    </GeneralSettingContext.Provider>
  );
};
